// dashboard-superadmin.api.ts
import { useQuery } from "@tanstack/react-query";
import { dashboardSuperAdminApi } from "./axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";
import {
  SuperAdminDashboardI,
  SuperAdminDashboardParamsI,
  ServiceResponseI,
} from "@interfaces";

const token = () => {
  const t = ValidateCurrentToken();
  if (!t) throw new Error("TOKEN INVALIDO");
  return t;
};

const handleErr = (err: unknown): never => {
  const obj = (err as AxiosError).response;
  if (obj?.status === 401) LogoutSystem();
  throw new Error((obj?.data as Error).message);
};

const getDashboard = async (
  params: SuperAdminDashboardParamsI,
): Promise<ServiceResponseI<SuperAdminDashboardI>> => {
  try {
    const p = new URLSearchParams();
    if (params.period)   p.append("period",   params.period);
    if (params.dateFrom) p.append("dateFrom", params.dateFrom);
    if (params.dateTo)   p.append("dateTo",   params.dateTo);

    const { data } = await dashboardSuperAdminApi.get<
      ServiceResponseI<SuperAdminDashboardI>
    >("", { params: p, headers: { Authorization: token() } });

    return data;
  } catch (err) { return handleErr(err); }
};

const getClientDetail = async (params: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<ServiceResponseI<any>> => {
  try {
    const p = new URLSearchParams();
    p.append("page",   String(params.page  ?? 1));
    p.append("limit",  String(params.limit ?? 10));
    p.append("search", params.search ?? "");

    const { data } = await dashboardSuperAdminApi.get<ServiceResponseI<any>>(
      "/clients",
      { params: p, headers: { Authorization: token() } },
    );
    return data;
  } catch (err) { return handleErr(err); }
};

export const useSuperAdminDashboard = (params: SuperAdminDashboardParamsI) => {
  const dashboardQuery = useQuery(
    ["superadmin-dashboard", params],
    () => getDashboard(params),
    { refetchOnWindowFocus: false, keepPreviousData: true },
  );
  return { dashboardQuery };
};

export const useSuperAdminClients = (params: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  const clientsQuery = useQuery(
    ["superadmin-clients", params],
    () => getClientDetail(params),
    { refetchOnWindowFocus: false, keepPreviousData: true },
  );
  return { clientsQuery };
};